export const PAGE_DATA_KEY = {
  HOME_PAGE: "HOME_PAGE",
  SOCIAL_CAUSE: "SOCIAL_CAUSE",
  ABOUT_US: "ABOUT_US",
  CONTACT_US: "CONTACT_US",
};
